import { render, staticRenderFns } from "./Redirecting.vue?vue&type=template&id=f4699532&"
import script from "./Redirecting.vue?vue&type=script&lang=js&"
export * from "./Redirecting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports